import React from 'react';
import cx from 'classnames';
import Panel from '../../../../components/outline/Panel';
import './VersionDetailPanel.scss';

const VersionDetailPanel = (props) => {
  const { className, name, title, children } = props;
  return (
    <Panel className={cx('version-detail-panel', className)} name={`${name}`}>
      <div className="panel-header">
        <div className="title">{title}</div>
      </div>

      {children}
    </Panel>
  );
};

export default VersionDetailPanel;
